import { render, staticRenderFns } from "./LocationMarker.vue?vue&type=template&id=60dada02&"
import script from "./LocationMarker.vue?vue&type=script&lang=js&"
export * from "./LocationMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60dada02')) {
      api.createRecord('60dada02', component.options)
    } else {
      api.reload('60dada02', component.options)
    }
    module.hot.accept("./LocationMarker.vue?vue&type=template&id=60dada02&", function () {
      api.rerender('60dada02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationMarker.vue"
export default component.exports